export const AffiliateRoute = {
  ReferralStats: (): string => '/dashboard/referral/stats',
  ReferralLinks: (): string => '/dashboard/referral/links',
  ReferralHistory: (): string => '/dashboard/referral/history',
};
